import React from 'react';
import styled from 'styled-components';
import { Body5 } from '@ui';
import { SkeletonButton } from '@ui/buttons';
import { DocumentVaultSelectionContext } from '@/contexts/DocumentVaultSelectionContext';

const BannerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;

  padding: 8px 12px;
  background: ${({ theme }) => theme.themeColors.componentNoOpacity};
  border: 1px solid ${({ theme }) => theme.themeColors.lowContrastBorder};
  border-radius: 4px;
`;

/*
  Appears only when the page is fully selected and more matches exist beyond it -- otherwise
  "all selected" quietly means "all on this page", which is how someone downloads 50 of 300.
*/
export const SelectAllMatchingBanner = ({ pageCount, filteredCount }) => {
  const { isSelectAllMatching, selectedCount, selectAllMatching, clearSelection } =
    React.useContext(DocumentVaultSelectionContext);

  const isPageFullySelected = pageCount > 0 && selectedCount >= pageCount;
  const hasMoreBeyondPage = filteredCount > pageCount;

  if (!hasMoreBeyondPage || !isPageFullySelected) return null;

  if (isSelectAllMatching) {
    return (
      <BannerWrapper>
        <Body5>All {filteredCount} documents matching these filters are selected.</Body5>
        <SkeletonButton onClick={clearSelection}>Clear selection</SkeletonButton>
      </BannerWrapper>
    );
  }

  return (
    <BannerWrapper>
      <Body5>All {pageCount} on this page are selected.</Body5>
      <SkeletonButton onClick={selectAllMatching}>Select all {filteredCount} matching</SkeletonButton>
    </BannerWrapper>
  );
};
